import React, { useEffect, useState } from 'react';
import axios from 'axios';

// STYLE
import './style.css';

// API
import { apiUrl } from '../../../config/apiConfig';
import api from '../../../services/api';

// CONTEXT API
import { useUser } from '../../../contexts/userContext';

// ASSETS
import Logo from '../../../assets/logo-suite-flow.ico'

// COMPONENTS
import UpdateUser from '../UpdateUser';

const ListUsers = () => {

  // CONTEXT API
  const { user, empresa } = useUser();

  // ESTADOS LOCAL
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const { openCloseUpdateUser, openModalUpdateUser } = useUser();
  const ambiguousCommercialUsers = users.filter(
    (item) => item.commercial_supervisor_status === 'ambiguous',
  );

  const commercialSupervisorLabel = (item) => {
    if (item.commercial_supervisor_status === 'assigned') {
      return `Supervisor: ${(item.commercial_supervisor_names || []).join(', ')}`;
    }
    if (item.commercial_supervisor_status === 'ambiguous') {
      return `Conflito: ${(item.commercial_supervisor_names || []).join(', ')}`;
    }
    if (item.commercial_supervisor_status === 'unassigned') {
      return 'Sem Supervisor Comercial';
    }
    return null;
  };

  // BUSCAR USUÁRIOS POR empresa_id
  // useEffect(() => {
  //   const fetchUsers = async () => {
  //     setFilteredUsers(users);
  //     if (user && user.empresa_id) {
  //       try {
  //         const config = {
  //           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  //         };
  //         const response = await axios.get(`${apiUrl}/users/list-by-company?empresa_id=${user.empresa_id}`, config);
  //         setUsers(response.data);
  //         setFilteredUsers(response.data);
  //       } catch (error) {
  //         console.error('Erro ao buscar usuários:', error);
  //         setUsers([]);
  //       }
  //     }
  //   };

  //   fetchUsers();
  // }, [user]);

  useEffect(() => {
    const fetchUsers = async () => {
      setFilteredUsers(users);
      if (user && user.empresa_id) {
        try {
          const response = await api.get(`/users/list-by-company?empresa_id=${user.empresa_id}`);
          setUsers(response.data);
          setFilteredUsers(response.data);
        } catch (error) {
          console.error("Erro ao buscar usuários:", error);
          setUsers([]);
        }
      }
    };
  
    fetchUsers();
  }, [user]);
  

  // ABRIR MODAL COM INFORMAÇÕES DE UM USUÁRIO
  function updateUser(user) {
    setSelectedUser(user);
    openModalUpdateUser();
  }

  // ORDENAR POR username OU state OU is_active
  const orderUsersBy = (key) => {
    setOrderBy(key);
    const sortedUsers = [...filteredUsers].sort((a, b) => {
      if (key === 'username') {
        return a[key].localeCompare(b[key]);
      } else if (key === 'state') {
        return a[key].localeCompare(b[key]);
      } else if (key === 'is_active') {
        return (a[key] === b[key]) ? 0 : a[key] ? -1 : 1;
      }
      return 0;
    });
    setFilteredUsers(sortedUsers);
  };

  // FILTRAR POR username
  useEffect(() => {
    const filterUsers = (term) => {
      if (term === '') {
        setFilteredUsers(users);
      } else {
        const updatedList = users.filter(user =>
          user.username.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredUsers(updatedList);
      }
    };
    filterUsers(searchTerm);
  }, [searchTerm, users]);

  return (
    <div className='list-users-container-modal'>
      {users.length > 0 ? (
        <div className='list-users-container'>
          {ambiguousCommercialUsers.length > 0 && (
            <div className='commercial-supervisor-alert' role='alert'>
              <strong>Conflito de Supervisor Comercial</strong>
              <span>
                {ambiguousCommercialUsers.length} vendedor(es) possuem mais de um supervisor.
                Corrija os vínculos destacados para evitar atribuição ambígua no Dashboard Comercial.
              </span>
            </div>
          )}
          <div className='search-user-container'>
            <input
              className='search-user-input'
              placeholder="Buscar usuário pelo nome..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
            <label className='label-order-by-users'>Ordenar por:</label>
            <button className='btn-order-by-users' onClick={() => orderUsersBy('username')} style={{ backgroundColor: orderBy === 'username' ? 'dodgerblue' : '#aaaaaa' }}>Nome</button>
            <button className='btn-order-by-users' onClick={() => orderUsersBy('is_active')} style={{ backgroundColor: orderBy === 'is_active' ? 'dodgerblue' : '#aaaaaa' }}>Ativos</button>
            <button className='btn-order-by-users' onClick={() => orderUsersBy('state')} style={{ backgroundColor: orderBy === 'state' ? 'dodgerblue' : '#aaaaaa' }}>Estado</button>
          </div>

          <label style={{ fontSize: '12px' }}>{users.length} usuários / {empresa.numero_de_licencas} licenças | {users.filter(u => u.is_active === true).length} ativos / {users.filter(u => u.is_active !== true).length} inativos</label>
          <div className='list-user-form-container'>
            {filteredUsers.map((user) => (
              <li key={user.id} className='item-list-users' onClick={() => updateUser(user)}>
                <div className='list-user-logo-container'>
                  {/* <img className='list-users-logo' src={user.avatar ? user.avatar : Logo} alt={`${user.username}'s avatar`} style={{ height: 50 }} /> */}
                  <img
                    className='list-users-logo'
                    src={user.avatar ? (user.avatar.includes('syncs-avatar') ? require(`../../../assets/avatares/${user.avatar}`) : user.avatar) : Logo}
                    alt={`${user.username}'s avatar`}
                    style={{ height: 50 }}
                  />

                </div>
                <div className='list-user-identification'>
                  <label className='list-user-label-username'>{user.username} - {user.state}</label>
                  {commercialSupervisorLabel(user) && (
                    <span
                      className={`commercial-supervisor-status commercial-supervisor-status-${user.commercial_supervisor_status}`}
                    >
                      {commercialSupervisorLabel(user)}
                    </span>
                  )}
                </div>
                <div className='list-user-logo-container'>
                  <label className='label-is-active' style={{ background: user.is_active === true ? '#8EC045' : '#aaaaaa' }}>{user.is_active == true ? 'Ativo' : 'Inativo'}</label>
                </div>
              </li>
            ))}
          </div>

        </div>
      ) : (
        <p>Nenhum usuário encontrado.</p>
      )}

      {openCloseUpdateUser && (
        <UpdateUser user={selectedUser} />
      )}

    </div>
  );
};

export default ListUsers;
